import React, { useState, useEffect } from 'react';
import '../css/ActivityLoggingPage.css';
import UserFooter from './UserFooter';
import ProfileNavBar from './ProfileNavBar';
import ChatBot from './ChatBot';
import Footer from './Footer';
import { FaRunning, FaWalking, FaSwimmer } from "react-icons/fa";
import { GiCycling, GiNightSleep } from "react-icons/gi";
import { CgGym } from "react-icons/cg";
import { GrYoga } from "react-icons/gr";
import { GiMeditation } from "react-icons/gi";
import ChatComponent from './ChatComponent';

const ActivityLoggingPage = () => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [userPlanID, setUserPlanID] = useState(null);
  const [currentActivity, setCurrentActivity] = useState({});
  const [customActivities, setCustomActivities] = useState([]);
  const [showNewActivityForm, setShowNewActivityForm] = useState(false);
  const [dayType, setDayType] = useState(null);

  if (!user) {
    window.location.href = '/login';
  }

  useEffect(() => {
    fetch('https://18.117.231.157/api/getuserplan', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userID: user.userID })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setUserPlanID(data.plan);
      })
      .catch((err) => console.error('Error fetching user plan:', err));
  }, [user.userID]);

  const activityOptions = [
    { type: 'sleep', icon: <GiNightSleep />, label: 'Sleep', selections: [8, 10, 12] },
    { type: 'workout', icon: <CgGym />, label: 'Workout', selections: [10, 20, 30, 45] },
    { type: 'steps', icon: <FaWalking />, label: 'Steps', selections: [2000, 5000, 10000] },
    { type: 'cycling', icon: <GiCycling />, label: 'Cycling', selections: [10, 20, 30, 45] },
    { type: 'running', icon: <FaRunning />, label: 'Running', selections: [10, 20, 30, 45] },
    { type: 'yoga', icon: <GrYoga />, label: 'Yoga', selections: [10, 20, 30, 45] },
    { type: 'meditation', icon: <GiMeditation />, label: 'Meditation', selections: [10, 20, 30, 45] },
    { type: 'swimming', icon: <FaSwimmer />, label: 'Swimming', selections: [10, 20, 30, 45] }
  ];

  const handleInputChange = (event, type) => {
    setCurrentActivity({ ...currentActivity, [type]: event.target.value });
  };

  const handleSelection = (e, type, value) => {
    e.preventDefault();
    setCurrentActivity({ ...currentActivity, [type]: value });
  };

  const handleNewActivitySubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const newActivity = {
      activityName: formData.get("name"),
      description: formData.get("description"),
      unit: formData.get("unit"),
      value: parseInt(formData.get("target")) || 0
    };
    setCustomActivities((prev) => [...prev, newActivity]);
    setShowNewActivityForm(false);
  };

  const handleSubmitAllActivities = async (e) => {
    e.preventDefault();

    const userID = user.userID;
    const activityLogPayload = {
      userID,
      dayType,
      sleep: parseInt(currentActivity.sleep) || 0,
      workout: parseInt(currentActivity.workout) || 0,
      walking: parseInt(currentActivity.steps) || 0,
      cycling: parseInt(currentActivity.cycling) || 0,
      running: parseInt(currentActivity.running) || 0,
      yoga: parseInt(currentActivity.yoga) || 0,
      meditation: parseInt(currentActivity.meditation) || 0,
      swimming: parseInt(currentActivity.swimming) || 0,
      activePlan: userPlanID || 'none'
    };

    try {
      const res1 = await fetch("https://18.117.231.157/api/logActivity", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(activityLogPayload)
      });

      let success1 = (await res1.json()).success;
      let success2 = true;

      if (customActivities.length > 0) {
        const res2 = await fetch("https://18.117.231.157/api/addUserActivities", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userID, activities: customActivities })
        });
        success2 = (await res2.json()).success;
      }

      if (success1 && success2) {
        alert("All activities submitted successfully!");
        window.location.href = '/logs'
        setCurrentActivity({});
        setCustomActivities([]);
        setShowNewActivityForm(false);
        setDayType(null);
      } else {
        alert("Some activities failed to submit.");
      }
    } catch (err) {
      console.error("Error submitting activities:", err);
      alert("Server error.");
    }
  };
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div>
      <ProfileNavBar />
      <br /><br /><br /><br /><br /><br />
      <h1 className='contactuspageheaders'>
        Log Today's Activity
        {dayType !== null && (
          <button className='backbutton' onClick={() => setDayType(null)}>🔙</button>
        )}
      </h1>
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button type="button" className="goals" onClick={() => window.location.href = '/logs'}>
                Go To Activity Logs
              </button>
            </div>
        <div>
          <form className='activityloggingform'>
          {(Object.keys(currentActivity).length > 0 || customActivities.length > 0) && (
            <div className="loginform" style={{ marginTop: '20px' }}>
              <h3 className="contactuspageheaders">📝 Activities to Submit:</h3>
              <ul style={{ textAlign: 'left', marginInline: 'auto', maxWidth: '500px' }}>
                {Object.entries(currentActivity).map(([key, val]) => (
                  val > 0 && <li key={key}><strong>{capitalize(key)}</strong>: {val}</li>
                ))}
                {customActivities.map((act, idx) => (
                  <li key={idx}>
                    <strong>{act.activityName}</strong> — {act.value} {act.unit}<br />
                    <em>{act.description}</em>
                  </li>
                ))}
              </ul>
              <button type="button" className="submitbutton" onClick={handleSubmitAllActivities}>
                ✅ Submit All Activities
              </button>
            </div>
          )}
          <br></br>
            <div className='grid-container'>
              {activityOptions.map((activity, index) => (
                <div key={index} className={`item${index + 1}`}>
                  {React.cloneElement(activity.icon, { className: 'icon' })}
                  <label>{activity.label}</label>
                  <input
                    className='inputa'
                    type='number'
                    placeholder={`Enter No. of ${activity.label === 'Sleep' ? 'Hours' : 'Minutes'}`}
                    value={currentActivity[activity.type] || ''}
                    onChange={(e) => handleInputChange(e, activity.type)}
                  />
                  <div className='selections'>
                    {activity.selections.map(value => (
                      <button key={value} onClick={(e) => handleSelection(e, activity.type, value)}>{value}</button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </form>
          <br></br>
          {!showNewActivityForm && (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button type="button" className="goals" onClick={() => setShowNewActivityForm(true)}>
                ➕ Create Your Own Workout Activity
              </button>
            </div>
          )}

          {showNewActivityForm && (
            <form className="loginform" onSubmit={handleNewActivitySubmit}>
              <h2 className='contactuspageheaders'>Add Your Own New Activity</h2>
              <label>Name</label>
              <input type="text" name="name" placeholder="e.g. Meditation" required />
              <label>Description</label>
              <input type="text" name="description" placeholder="Brief description" required />
              <label>Unit</label>
              <input type="text" name="unit" placeholder="e.g. minutes, servings" required />
              <label>Value</label>
              <input type="number" name="target" placeholder="e.g. 10, 100" required />
              <div className='rowtype'>
                <button type="submit" className="submitbutton">Add Activity</button>
                <button type="button" className="submitbutton" onClick={() => setShowNewActivityForm(false)}>Cancel ❌</button>
              </div>
            </form>
          )}
        </div>
      
      <ChatComponent/>
      <br></br>
      <UserFooter />
      <Footer />
    </div>
  );
};

export default ActivityLoggingPage;
